import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBrackets12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextBrackets12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M0 2.8c0-.966.784-1.75 1.75-1.75H3a.5.5 0 0 1 0 1H1.75A.75.75 0 0 0 1 2.8v7.4c0 .414.336.75.75.75H3a.5.5 0 0 1 0 1H1.75A1.75 1.75 0 0 1 0 10.2zm12 0a1.75 1.75 0 0 0-1.75-1.75H9a.5.5 0 0 0 0 1h1.25a.75.75 0 0 1 .75.75v7.4a.75.75 0 0 1-.75.75H9a.5.5 0 0 0 0 1h1.25A1.75 1.75 0 0 0 12 10.2zM3.5 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM3 8.5a.5.5 0 0 1 .5-.5h3.332a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextBrackets12);
